import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { onFormChangeUniversal } from '../../functions/onFormChange';
import { WFormData } from '../../../../core/forms/WFormFramework';

export function getAssistentConfigCfmMotivation(dataGlobal: any, standort: any, jahr: number): AssistentItem {
    const config = {
        gliederung: '1.1',
        name: 'Motivation/Bilanzgrenzen',
        description: 'Dies ist das Formular zur Eingabe der Daten der Motivation/Zielsetzung.',
        type: 'EntityForm',
        entity: IDs.ENT_CFM_MOTIVATION,
        module: IDs.MOD_ETOOL,
        singleItem: true,
        // disablePruefer: true,
        configFlag: 'checkCfmMotivation',
        style: { marginLeft: 18 },
        infoTextKey: 'hinweis_cfm_motivation',
        infoTextStyle: { maxWidth: 600 },
        customCssStyle: {
            formField: {
                motivation: { styleTextarea: { height: 150 } },
                vorstellung: { styleTextarea: { height: 150 } },
                systemgrenzen: { styleTextarea: { height: 150 } },
                umweltzertifizierungen: { styleTextarea: { height: 150 } }
            }
        },
        onFormChangeInteractive: (formData: WFormData, onValueChange: (name: string, value: any) => void) => {
            let oldFormValues;
            if (standort && jahr) {
                if (!((formData || {} as any).values || {}).jahr) {
                    formData.setValue('jahr', jahr);
                }
                oldFormValues = (dataGlobal[IDs.ENT_CFM_MOTIVATION] || []).find((r: any) => r.jahr === jahr);
                // oldFormValues = ((dataGlobal || {})[IDs.ENT_CFM_MOTIVATION] || [])[0];
                // oldFormValues = (dataGlobal[IDs.ENT_CFM_MOTIVATION] || []).find((r: any) => r.standort_tid_orig === standort.tid && r.jahr === jahr);
            }
            onFormChangeUniversal(IDs.ENT_CFM_MOTIVATION, formData, null, dataGlobal, oldFormValues);
        }
    };
    return config;
}
